import styled from '@emotion/styled';

import { borderRadius, mediaMax, spacing } from 'presentations/views/styles';
import {
  gray01,
  gray04,
  primary,
  white,
} from 'presentations/views/styles/color';
import { ReactNode, SyntheticEvent, useCallback } from 'react';
import Tooltip from 'presentations/views/components/atoms/Tooltip';

interface Props {
  value: string | number;
  onChange: (props: { value: string }) => void;
  items: Array<{
    value: string | number;
    label: string | ReactNode;
    tooltip?: string;
  }>;
  className?: string;
  isFillColor?: boolean;
}

export default function Component(props: Props) {
  const onClick = (e: SyntheticEvent<HTMLDivElement>) => {
    if (!e.currentTarget.dataset.value) return;
    const value = String(e.currentTarget.dataset.value);
    return props.onChange({ value });
  };

  return (
    <Container className={props.className}>
      {props.items.map((item, index) => (
        <ToggleButton
          onClick={onClick}
          data-value={item.value}
          key={item.value}
          isSelected={item.value === props.value}
          isFillColor={item.value === props.value && !!props.isFillColor}
        >
          {item.tooltip ? (
            <Tooltip title={item.tooltip}>{item.label}</Tooltip>
          ) : (
            item.label
          )}
        </ToggleButton>
      ))}
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  align-items: center;
`;
const ToggleButton = styled.div<{ isSelected: boolean; isFillColor: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border: 1px solid ${(props) => (props.isSelected ? primary : gray04)};
  height: 32px;
  min-width: 80px;
  padding: 0 ${spacing(16)};
  white-space: nowrap;
  border-right-width: ${(props) => (props.isSelected ? 1 : 0)};
  :first-of-type {
    border-top-left-radius: ${borderRadius(4)};
    border-bottom-left-radius: ${borderRadius(4)};
  }
  :last-of-type {
    border-top-right-radius: ${borderRadius(4)};
    border-bottom-right-radius: ${borderRadius(4)};
    border-right-width: 1px;
  }
  background-color: ${(props) => (props.isFillColor ? primary : white)};
  color: ${(props) =>
    props.isSelected ? (props.isFillColor ? white : primary) : gray01};

  line-height: 1;

  ${mediaMax.tablet} {
    min-width: 60px;
    height: 29px;
  }
`;
